export default function Marquee({ items }) {
  const row = [...items, ...items];
  return (
    <div className="overflow-hidden border-y border-border bg-card py-3" data-testid="marquee">
      <div className="marquee-track">
        {row.map((t, i) => (
          <span key={i} className="mono-label mx-6 inline-flex items-center gap-6 text-muted-foreground">
            {t}
            <span className="h-1 w-1 bg-primary" aria-hidden />
          </span>
        ))}
      </div>
    </div>
  );
}
